/* eslint-disable no-nested-ternary */

import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Box, Button, Stack, Divider, useMediaQuery, FormControl, TextField, FormHelperText, ListItemText, Checkbox, IconButton, Tooltip, Alert, Autocomplete, Paper, FormControlLabel, CircularProgress } from '@mui/material';


import { Icon as Iconify } from '@iconify/react';


import CloseIcon from '@mui/icons-material/Close';


import { useForm } from 'react-hook-form';

import SchemeDefinationService from '../../../services/schemedefination.service';
import LoadingProgressBar from '../../../components/loading-progressbar/loadingprogressbar';
import SchemeTargetDataGrid from '../Others/SchemeTargetDataGrid';

import ConfirmationPopup from '../Others/ConfirmationPopup';
import { useSchemeStore } from '../schemeStore';

const custom = ({ targetSubClassification, selectedValues, searchedValue, setSelectedValues, setValue, ...paperProps }) => {  // NOSONAR
    const { children, ...restPaperProps } = paperProps;
    const filteredOptions =
        targetSubClassification?.DefaultValues?.filter(item =>
            item?.[targetSubClassification?.DisplayExpr]?.toLowerCase().includes(searchedValue?.toLowerCase() || '')
        ) || [];

    const isAllFilteredSelected = selectedValues.length > 0 && filteredOptions.every(option =>
        selectedValues.some(selected => selected[targetSubClassification.ValueExpr] === option[targetSubClassification.ValueExpr])
    );
    return (<Paper {...restPaperProps}>
        <Box onMouseDown={(e) => e.preventDefault()} sx={{ display: 'flex', height: '2rem', alignItems: 'center', paddingLeft: '2.142em' }}>
            <FormControlLabel
                onClick={(e) => {
                    e.preventDefault();
                    if (searchedValue.length > 0) {
                        if (isAllFilteredSelected) {
                            // Unselect filtered options
                            const newSelectedValues = selectedValues.filter(item =>
                                !filteredOptions.some(filtered => filtered[targetSubClassification.ValueExpr] === item[targetSubClassification.ValueExpr])
                            );
                            setSelectedValues(newSelectedValues);
                            setValue(targetSubClassification.ValueExpr, newSelectedValues.map(item => item[targetSubClassification.ValueExpr]));
                        } else {
                            // Select filtered options
                            const newSelectedValues = Array.from(new Set([...selectedValues, ...filteredOptions]));
                            setSelectedValues(newSelectedValues);
                            setValue(targetSubClassification.ValueExpr, newSelectedValues.map(item => item[targetSubClassification.ValueExpr]));
                        }
                    } else {
                        // eslint-disable-next-line no-lonely-if
                        if (selectedValues.length < targetSubClassification.DefaultValues.length) {
                            setSelectedValues(targetSubClassification.DefaultValues);
                            setValue(targetSubClassification.ValueExpr, targetSubClassification.DefaultValues.map(item => item[targetSubClassification.ValueExpr]));
                        } else {
                            setSelectedValues([]);
                            setValue(targetSubClassification.ValueExpr, []);
                        }
                    }
                }}
                label={
                    <span style={{ fontSize: '13px', paddingLeft: '0.7em' }}>
                        {searchedValue.length > 0
                            ? isAllFilteredSelected  // NOSONAR
                                ? 'Unselect filtered options'
                                : 'Select filtered options'
                            : selectedValues.length === targetSubClassification.DefaultValues.length  // NOSONAR
                                ? 'Unselect All'
                                : 'Select All'
                        }
                    </span>
                }
                control={
                    <Checkbox
                        size='small'
                        id="select-all-checkbox"
                        checked={targetSubClassification.DefaultValues.length > 0 && searchedValue.length > 0 ? isAllFilteredSelected : selectedValues.length === targetSubClassification.DefaultValues.length}
                    />
                }
            />
        </Box>
        <Divider />
        {children}
    </Paper>)
}


export default function SchemeTarget() { // NOSONAR

    const location = useLocation();
    const isCopyScheme = location.state?.data?.copyScheme;


    const {
        schemeDetails,
        schemeId,
        prevTabValue,
        tabValue,
        setTargetData,
        updateScheme,
        addScheme

    } = useSchemeStore();


    const [loading, setLoading] = useState(false);
    const [record, setRecord] = useState(null);
    const [target, setTarget] = useState([]);
    const [gridData, setGridData] = useState(null);
    const { id } = useParams();

    const [targetValues, setTargetValues] = useState({});
    const isSmallScreen = useMediaQuery('(max-width:600px)');


    const { register, handleSubmit, watch, formState: { errors }, setValue, unregister } = useForm();


    const [alertType, setAlertType] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [AutocompleteLoadingMap, setAutocompleteLoadingMap] = useState(new Map());


    const displayAlert = (type, message, show) => {
        setAlertType(type);
        setAlertMessage(message);
        setShowAlert(show);
    }
    const hideAlert = () => {
        setAlertType('');
        setAlertMessage('');
        setShowAlert(false);
    }

    const values = watch();
    const idKey = location.pathname.includes('schemedefination/newscheme') ? schemeId : id;

















    const onSubmit = async (data) => {


        const result = selectedValues || [];
        // Ensure that prevRecords is an array (in case it's null/undefined)
        setRecord(result);

    };



    useEffect(() => { // NOSONAR
        if (schemeDetails?.Target?.length > 0) {
            const payload = {
                Id: id,
                TargetOn: schemeDetails?.Target[0]?.TargetOn,
                SchemeTargetClassification: schemeDetails?.Target[0]?.TargetClassification
            };
            try {

                setLoading(true);
                SchemeDefinationService.then(schemeDefinationInstance => {
                    schemeDefinationInstance.GetSchemeTargetSubClassification(payload)
                        .then((response) => {
                            if (response.status === 200) {
                                const resp = response.data;
                                const autocompletePayload = [
                                    {
                                        "Classification": schemeDetails?.Target[0]?.TargetClassification,
                                        "ClassificationId": schemeDetails?.Target[0].TargetDetails.map(item => item[Object.keys(item).find(key => key.toLowerCase().includes("id"))]),
                                        "IsTarget": true
                                    }
                                ];

                                if (response.data.DataType === 'Autocomplete') {
                                    SchemeDefinationService.then(schemeDefinationInstancee => {
                                        schemeDefinationInstancee.GetSchemeAutocompleteText(autocompletePayload)
                                            .then((responsee) => {
                                                if (responsee.status === 200) {
                                                    resp.DefaultValues = responsee.data.Classification.map(classification => {
                                                        const targett = schemeDetails?.Target[0].TargetDetails.find(targetDetail => targetDetail.ClassificationId === classification.ClassificationId);

                                                        return {
                                                            ...classification,
                                                            Target: targett ? targett.TargetValue : null
                                                        };
                                                    });

                                                    const nowData = responsee.data.Classification.map(item => {

                                                        const targetValueObj = resp.DefaultValues.find(value => value.ClassificationId === item.ClassificationId).Target;
                                                        return {
                                                            ...item,  // Spread the original properties of the item
                                                            Target: targetValueObj,  // Add Target as the new property
                                                        };
                                                    });

                                                    setRecord(nowData);


                                                } else {
                                                     //  console.log("Error while fetching subclassification. Status:", responsee.status);
                                                     //  console.log("Error Message:", responsee.data);
                                                }
                                            })
                                            .catch((error) => {
                                                 //  console.log("Error:", error);

                                            });
                                    });
                                }

                                const defaultValues = resp.DefaultValues;
                                setTargetSubClassification(resp);
                                const targetDetails = schemeDetails?.Target[0].TargetDetails;


                                let combinedData;
                                if (response.data.DataType === 'Autocomplete') {
                                    combinedData = defaultValues;

                                } else {
                                    combinedData = targetDetails.map(targetDetail => {
                                        const matchedDefaultValue = defaultValues.find(defaultValue => defaultValue.ClassificationId === targetDetail.ClassificationId);
                                        if (matchedDefaultValue) {
                                            return {
                                                ...matchedDefaultValue,
                                                Target: targetDetail.TargetValue
                                            };
                                        }
                                        return null;
                                    }).filter(item => item !== null);
                                }
                                // Combine TargetDetails and DefaultValues



                                setGridData(combinedData);
                                setRecord(combinedData);
                                setTargetClassificationValue([schemeDetails?.Target[0]?.TargetClassification]);

                            } else {
                                 //  console.log("Error while fetching subclassification. Status:", response.status);
                                 //  console.log("Error Message:", response.data);
                            }
                            setLoading(false);
                        })
                        .catch((error) => {
                             //  console.log("Error:", error);
                            setLoading(false);
                        });


                });
            } catch (err) {
                 //  console.log('error ', err)
                setLoading(false);

            }
            finally {
                setLoading(false);
            }



        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



































    useEffect(() => {
        setLoading(true);
        try {  // NOSONAR
            SchemeDefinationService.then(schemeDefinationInstance => {
                schemeDefinationInstance.GetSchemeTargetDefinitionControls()
                    .then((response) => {
                        if (response.status === 200) {
                            setTarget(response.data);

                        } else {
                             //  console.log("Error while fetching user data. Status:", response.status);
                             //  console.log("Error Message:", response.data);
                        }
                        setLoading(false);

                    })
                    .catch((error) => {
                         //  console.log("Error:", error);
                        setLoading(false);

                    });
            });
        } catch (err) {
             //  console.log('error', err);
            setLoading(false);

        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [targetOn, setTargetOn] = useState(null);
    const [targetUOM, setTargetUOM] = useState(null);
    const [targetFulfilment, setTargetFulfilment] = useState(null);
    const [targetClassification, setTargetClassification] = useState(null);
    const [targetClassificationValue, setTargetClassificationValue] = useState([]);
    const [targetFulfilmentValue, setTargetFulfilmentValue] = useState(null);
    const [targetSubClassification, setTargetSubClassification] = useState(null);

    const [selectedValues, setSelectedValues] = useState([]);
























































































    useEffect(() => {
         //  console.log("loading state: ", loading);
    }, [loading]);

    const saveData = () => {

        childRef.current.handleSubmit();

    }



    const [targetData, setTargetDataa] = useState(); // NOSONAR

    useEffect(() => {
        if (prevTabValue.name === 'Target') {
            saveData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabValue]);

    


    
    const saveDataa = async (targetDetails) => {

        try {

            
            const targetPayload = {
                "TargetOn": targetOn || schemeDetails?.Target?.[0]?.TargetOn || null,
                "TargetUOM": targetUOM || schemeDetails?.Target?.[0]?.TargetUOM || null,
                "TargetFulfillment": targetFulfilment || schemeDetails?.Target?.[0]?.TargetFulfillment || null,
                "TargetClassification": targetClassificationValue?.[0] || schemeDetails?.Target?.[0]?.TargetClassification || null,
                "TargetFulfillmentValue": targetFulfilmentValue || schemeDetails?.Target?.[0]?.TargetFulfillmentValue || null,
                "TargetDetails": targetDetails || [],
            };

            const filteredPayload = Object.fromEntries(
                Object.entries(targetPayload).filter(([key, value]) => value !== null)
            );

            const payload = schemeDetails;
            payload.FromDate = payload.From_FromDate;
            payload.ToDate = payload.To_ToDate;
            payload.From_FromDate = undefined;
            payload.To_ToDate = undefined;
            if (targetDetails.length > 0) {
                payload.Target = [filteredPayload];
                payload.SchemeData.IncludeTarget = true;
                setTargetData([filteredPayload])

            } else {

                 //  console.log("targetPayload: ", []);
                setTargetData(null)
                
            }
             //  console.log("prevTabValue.name: ", prevTabValue.name, " Condition: ", prevTabValue.name !== 'Target');
            if (prevTabValue.name !== 'Target') {
                try {
                    if (isCopyScheme) {
                        const result = await addScheme(); // NOSONAR
                    } else {

                        const result = await updateScheme(); // NOSONAR
                    }
                } catch (err) {
                    // handle error
                }
            }
            

        } catch (error) {
            console.error('Error occured: ', error);
            setLoading(false);


            displayAlert('success', error, true);
            setTimeout(() => {
                hideAlert();
            }, 2000);

        }
    }














































    const getClassification = (name) => {
        setLoading(true);
        try { // NOSONAR
            SchemeDefinationService.then(schemeDefinationInstance => {
                let request;

                if (name === 'Executive') {
                    request = schemeDefinationInstance.GetExecutiveDefinitionControls('Executive');
                } else {
                    request = schemeDefinationInstance.GetSchemeTargetClassification(name);
                }

                request
                    .then((response) => {
                        if (response.status === 200) {
                            setTargetClassification(response.data);
                        } else {
                            // console.log("Error while fetching controls. Status:", response.status);
                            // console.log("Error Message:", response.data);
                        }
                    })
                    .catch((error) => {
                        // console.log("Error:", error);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            });
        } catch (error) {
            // console.log("Unexpected Error:", error);
            setLoading(false);
        }
    };



    const getSubClassification = (classificationValue) => {
        const payload = {
            Id: id,
            TargetOn: targetOn,
            SchemeTargetClassification: classificationValue
        }
        setLoading(true);
        try { // NOSONAR
            SchemeDefinationService.then(schemeDefinationInstance => {
                schemeDefinationInstance.GetSchemeTargetSubClassification(payload)
                    .then((response) => {
                        if (response.status === 200) {
                            setTargetSubClassification(response.data);

                        } else {
                             //  console.log("Error while fetching subclassification. Status:", response.status);
                             //  console.log("Error Message:", response.data);
                        }
                        setLoading(false);

                    })
                    .catch((error) => {
                         //  console.log("Error:", error);
                        setLoading(false);
                    });
            });
        } catch (err) {
             //  console.log('error', err)
            setLoading(false);

        }
    }


    useEffect(() => {
        if (targetClassification) {
            setTargetSubClassification(null);
            setSelectedValues([]);

            // Unregister sub-classification fields if any
            if (targetSubClassification) {
                unregister(targetSubClassification.ValueExpr);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [targetClassification]);

    useEffect(() => {
        if (targetOn) {
            setTargetClassification(null);
            setTargetSubClassification(null);
            setTargetUOM(null);
            setTargetFulfilment(null);
            setTargetFulfilmentValue(null);
            setTargetClassificationValue([]);
            setSelectedValues([]);

            // Reset form values



            Object.keys(values).forEach(field => {
                if (field !== "TargetOn") {
                    setValue(field, '');
                }
            });


            // Unregister sub-classification fields if any
            if (targetSubClassification) {
                unregister(targetSubClassification.ValueExpr);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [targetOn]);

    const childRef = useRef();



    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);

    const handleConfirm = (confirmed) => {
        setIsConfirmationOpen(false); // Close the modal
        if (confirmed && pendingAction) {
            pendingAction(); // Execute the pending action
        }
    };




   
    useEffect(() => {
        setValue('TargetOn', '')
        setValue('TargetClassification', '')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [searchedValue, setSearchedValue] = useState('');



    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
            <form onSubmit={handleSubmit(onSubmit)} style={{ minHeight: 0, display: 'flex', flexDirection: 'column', flexGrow: 1, }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minHeight: 0, justifyContent: 'flex-start', overflow: isSmallScreen ? 'auto' : 'hidden', }}>
                    {
                        target && target.length > 0 &&
                        <Box >
                            <Box
                                rowGap={2}
                                columnGap={2}
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(1, 1fr)',
                                    sm: 'repeat(3, 1fr)',
                                }}
                                gridAutoRows='min-content'

                                sx={{ mt: 1, paddingTop: '0.4rem', }}

                            >
                                <FormControl fullWidth >
                                    <style>
                                        {`.css-1d1wxla-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {color: #424242 !important;}`}
                                        {`.css-icr2t7-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {color: #424242 !important;}`}
                                    </style>
                                    {/* <InputLabel size='small' sx={{ fontSize: '14px' }}>{target[0]?.LabelName}</InputLabel> */}
                                    <Autocomplete
                                        value={targetOn !== null ?
                                            target[0]?.DefaultValues.find(item => item[target[0]?.ValueExpr] === targetOn) || null :
                                            null
                                        }
                                        {...register(target[0]?.ValueExpr, target[0]?.Validations[0].ValidationType === 'Required' && { required: target[0]?.Validations[0].ValidationMessage })}

                                        options={target[0]?.DefaultValues || []}
                                        getOptionLabel={(option) => option[target[0]?.DisplayExpr] || ''}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={<>
                                                    {target[0]?.LabelName}
                                                    {target[0]?.Validations && target[0]?.Validations.length > 0 && target[0]?.Validations[0].ValidationType === 'Required' && (
                                                        <span style={{ color: 'red' }}> *</span>
                                                    )}
                                                </>}
                                                size="small"
                                                sx={{
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '13px',  // Set text size to 13px
                                                    },
                                                    '& .MuiFormLabel-root': {
                                                        fontSize: '14px',  // Set label text size to 14px
                                                    },
                                                }}
                                            />
                                        )}
                                            onChange={(event, newValue, reason) => {

                                                if (!(reason === 'removeOption' && event.type === 'keydown')) {


                                                    const selectedValue = newValue ? newValue[target[0]?.ValueExpr] : '';

                                                    // Safely access schemeDefinationData.Target if it exists and has at least one element
                                                    const targetOnValue = schemeDetails?.Target?.length ? schemeDetails?.Target[0].TargetOn : null;

                                                    if (
                                                        (values.TargetOn === '' && selectedValue === targetOnValue) ||
                                                        values.TargetOn === selectedValue
                                                    ) {

                                                        setTargetOn(selectedValue);
                                                        getClassification(selectedValue);
                                                        setValue(target[0]?.ValueExpr, selectedValue);
                                                        return;
                                                    }
                                                    if (record?.length > 0) {

                                                        // Show the confirmation modal instead of window.confirm()
                                                        setIsConfirmationOpen(true);
                                                        setPendingAction(() => () => {

                                                            // This function will be executed after user confirms
                                                            setGridData([]);
                                                            setRecord([]);
                                                            setTargetValues({});
                                                            setTargetOn(selectedValue);
                                                            getClassification(selectedValue);
                                                            setValue(target[0]?.ValueExpr, selectedValue);
                                                        });

                                                    } else {

                                                        setTargetOn(selectedValue);
                                                        getClassification(selectedValue);
                                                        setValue(target[0]?.ValueExpr, selectedValue);
                                                    }
                                                }
                                        }}
                                        size="small"
                                        sx={{ fontSize: '13px' }}
                                        ListboxProps={{
                                            style: {
                                                maxHeight: '224px',
                                                '& .MuiAutocomplete-option': {
                                                    fontSize: '13px',  // Set the font size for the options
                                                },
                                            },
                                        }}
                                        renderOption={(props, option) => (
                                            <li {...props} style={{ fontSize: '13px' }}>
                                                {option[target[0]?.DisplayExpr]}
                                            </li>
                                        )}
                                    />
                                    {errors?.TargetOn && (targetOn === null || targetOn === undefined || values?.TargetOn === '') && (
                                        <FormHelperText sx={{ color: 'red', fontSize: '10px' }}>
                                            {errors.TargetOn.message || "Target On Required"}
                                        </FormHelperText>
                                    )}
                                </FormControl>

                                <FormControl fullWidth>
                                    <style>
                                        {`.css-1d1wxla-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {color: #424242 !important;}`}
                                        {`.css-icr2t7-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {color: #424242 !important;}`}
                                    </style>
                                    {/* <InputLabel size='small' sx={{ fontSize: '14px' }}>{target[1]?.LabelName}</InputLabel> */}
                                    <Autocomplete
                                        value={targetUOM !== null ?
                                            target[1]?.DefaultValues.find(item => item[target[1]?.ValueExpr] === targetUOM) || null :
                                            null
                                        }
                                        options={target[1]?.DefaultValues || []}
                                        getOptionLabel={(option) => option[target[1]?.DisplayExpr] || ''}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={<>
                                                    {target[1]?.LabelName}
                                                    {target[1]?.Validations && target[1]?.Validations.length > 0 && target[1]?.Validations[0].ValidationType === 'Required' && (
                                                        <span style={{ color: 'red' }}> *</span>
                                                    )}
                                                </>}
                                                size="small"
                                                sx={{
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '13px',  // Set text size to 13px
                                                    },
                                                    '& .MuiFormLabel-root': {
                                                        fontSize: '14px',  // Set label text size to 14px
                                                    },
                                                }}
                                                {...register(target[1]?.ValueExpr, target[1]?.Validations[0].ValidationType === 'Required' && { required: target[1]?.Validations[0].ValidationMessage })}
                                            />
                                        )}
                                            onChange={(event, newValue, reason) => {
                                                if (!(reason === 'removeOption' && event.type === 'keydown')) {
                                                    const selectedValue = newValue ? newValue[target[1]?.ValueExpr] : '';
                                                    setTargetUOM(selectedValue);
                                                    setValue(target[1]?.ValueExpr, selectedValue);
                                                }
                                        }}
                                        ListboxProps={{
                                            style: {
                                                maxHeight: '224px',
                                                '& .MuiAutocomplete-option': {
                                                    fontSize: '13px',  // Set the font size for the options
                                                },
                                            },
                                        }}
                                        size="small"
                                        sx={{ fontSize: '13px' }}
                                        renderOption={(props, option) => (
                                            <li {...props} style={{ fontSize: '13px' }}>
                                                {option[target[1]?.DisplayExpr]}
                                            </li>
                                        )}
                                    />
                                    {errors[target[1]?.ValueExpr] && (targetUOM === null || targetUOM === undefined) && (
                                        <FormHelperText sx={{ color: 'red', fontSize: '10px' }}>{errors[target[1]?.ValueExpr]?.message}</FormHelperText>
                                    )}
                                </FormControl>

                                <FormControl fullWidth>
                                    <style>
                                        {`.css-1d1wxla-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {color: #424242 !important;}`}
                                        {`.css-icr2t7-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {color: #424242 !important;}`}
                                    </style>
                                    {/* <InputLabel size='small' sx={{ fontSize: '14px' }}>{target[2]?.LabelName}</InputLabel> */}
                                    <Autocomplete
                                        value={targetFulfilment !== null ?
                                            target[2]?.DefaultValues.find(item => item[target[2]?.ValueExpr] === targetFulfilment) || null :
                                            null
                                        }
                                        options={target[2]?.DefaultValues || []}
                                        getOptionLabel={(option) => option[target[2]?.DisplayExpr] || ''}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={<>
                                                    {target[2]?.LabelName}
                                                    {target[2]?.Validations && target[2]?.Validations.length > 0 && target[2]?.Validations[0].ValidationType === 'Required' && (
                                                        <span style={{ color: 'red' }}> *</span>
                                                    )}
                                                </>}
                                                size="small"
                                                sx={{
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '13px',  // Set text size to 13px
                                                    },
                                                    '& .MuiFormLabel-root': {
                                                        fontSize: '14px',  // Set label text size to 14px
                                                    },
                                                }}
                                                {...register(target[2]?.ValueExpr, target[2]?.Validations[0].ValidationType === 'Required' && { required: target[2]?.Validations[0].ValidationMessage })}
                                            />
                                        )}
                                            onChange={(event, newValue, reason) => {
                                                if (!(reason === 'removeOption' && event.type === 'keydown')) {
                                                    const selectedValue = newValue ? newValue[target[2]?.ValueExpr] : '';
                                                    setTargetFulfilment(selectedValue);
                                                    setValue(target[2]?.ValueExpr, selectedValue);
                                                }
                                        }}
                                        ListboxProps={{
                                            style: {
                                                maxHeight: '224px',
                                                '& .MuiAutocomplete-option': {
                                                    fontSize: '13px',  // Set the font size for the options
                                                },
                                            },
                                        }}
                                        size="small"
                                        sx={{ fontSize: '13px' }}
                                        renderOption={(props, option) => (
                                            <li {...props} style={{ fontSize: '13px' }}>
                                                {option[target[2]?.DisplayExpr]}
                                            </li>
                                        )}
                                    />
                                    {errors[target[2]?.ValueExpr] && (targetFulfilment === null || targetFulfilment === undefined || targetFulfilment === '') && (
                                        <FormHelperText sx={{ color: 'red', fontSize: '10px' }}>{errors[target[2]?.ValueExpr]?.message}</FormHelperText>
                                    )}
                                </FormControl>

                                {
                                    targetFulfilment && targetFulfilment.toString() === 'Min' && (
                                        <FormControl fullWidth>
                                            <style>
                                                {`.css-1d1wxla-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {color: #424242 !important;}`}
                                                {`.css-icr2t7-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {color: #424242 !important;}`}
                                            </style>
                                            <TextField
                                                fullWidth
                                                label="Target Fulfillment Value"
                                                variant="outlined"
                                                InputProps={{
                                                    style: {
                                                        fontSize: '13px',  // Set text size to 13px
                                                    },
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: '14px',  // Adjust label text size to 13px as well
                                                    },
                                                }}
                                                size='small'
                                                value={targetFulfilmentValue || ''}
                                                {...register('targetfulfilmentValue', { required: 'Target Fulfillment Value Required' })}
                                                onChange={(e) => {
                                                    setTargetFulfilmentValue(e.target.value);
                                                    setValue('targetfulfilmentValue', e.target.value);
                                                }}
                                            />
                                            {errors.targetfulfilmentValue && (targetFulfilmentValue === null || targetFulfilmentValue === undefined || targetFulfilmentValue === '') && (
                                                <FormHelperText sx={{ color: 'red', fontSize: '10px' }}>{errors.targetfulfilmentValue?.message}</FormHelperText>
                                            )}
                                        </FormControl>
                                    )
                                }

                                {
                                    targetClassification && targetClassification.length > 0 &&
                                        targetClassification.map((control, index) => (    // NOSONAR
                                        <FormControl fullWidth key={index}>  { /* NOSONAR */}
                                            <style>
                                                {`.css-1d1wxla-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {color: #424242 !important;}`}
                                                {`.css-icr2t7-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {color: #424242 !important;}`}
                                            </style>
                                            {/*  <InputLabel size='small' sx={{ fontSize: '14px' }} >{control?.LabelName}</InputLabel> */}
                                            <Autocomplete
                                                value={(targetClassificationValue.length > 0 && targetClassificationValue[index] !== null) ?
                                                    control.DefaultValues.find(item => item[control.ValueExpr] === targetClassificationValue[index]) || null :
                                                    null
                                                }
                                                {...register(control?.ValueExpr, control?.Validations[0].ValidationType === 'Required' && { required: control?.Validations[0].ValidationMessage })}
                                                options={control.DefaultValues || []}
                                                getOptionLabel={(option) => option[control.DisplayExpr] || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label={control.LabelName}
                                                        size="small"
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '13px',  // Set text size to 13px
                                                            },
                                                            '& .MuiFormLabel-root': {
                                                                fontSize: '14px',  // Set label text size to 14px
                                                            },
                                                        }}
                                                    />
                                                )}
                                                    onChange={(event, newValue, reason) => {
                                                        if (!(reason === 'removeOption' && event.type === 'keydown')) {
                                                            const selectedValue = newValue ? newValue[control.ValueExpr] : '';

                                                            // Safely access schemeDefinationData.Target if it exists and has at least one element
                                                            const targetClassificationn = schemeDetails?.Target?.length ? schemeDetails?.Target[0]?.TargetClassification : null;

                                                            if (
                                                                (values.TargetClassification === '' && selectedValue === targetClassificationn) ||
                                                                values.TargetOn === selectedValue
                                                            ) {

                                                                const tempTargetClassification = [...targetClassificationValue];
                                                                setSelectedValues([]);  // Clear the selected values
                                                                setValue("ClassificationId", null);  // Reset ClassificationId to null
                                                                setSearchedValue('');
                                                                tempTargetClassification[index] = selectedValue;
                                                                setTargetClassificationValue(tempTargetClassification);  // Update target classification

                                                                setValue(control.ValueExpr, selectedValue);  // Set the value for the control
                                                                getSubClassification(selectedValue);  // Fetch subclassification based on the selected value

                                                                return;
                                                            }
                                                            if (record?.length > 0) {
                                                                // Show the confirmation modal instead of window.confirm()
                                                                setIsConfirmationOpen(true);
                                                                setPendingAction(() => () => {
                                                                    // This function will be executed after user confirms
                                                                    setGridData([]);
                                                                    setRecord([]);
                                                                    setTargetValues({});
                                                                    const tempTargetClassification = [...targetClassificationValue];
                                                                    setSelectedValues([]);
                                                                    setSearchedValue('');

                                                                    setValue("ClassificationId", null);
                                                                    tempTargetClassification[index] = selectedValue;
                                                                    setTargetClassificationValue(tempTargetClassification);
                                                                    setValue(control.ValueExpr, selectedValue);
                                                                    getSubClassification(selectedValue);
                                                                });
                                                            } else {
                                                                const tempTargetClassification = [...targetClassificationValue];
                                                                setSelectedValues([]);
                                                                setSearchedValue('');

                                                                setValue("ClassificationId", null);
                                                                tempTargetClassification[index] = selectedValue;
                                                                setTargetClassificationValue(tempTargetClassification);
                                                                setValue(control.ValueExpr, selectedValue);
                                                                getSubClassification(selectedValue);
                                                            }
                                                        }
                                                }}
                                                size="small"
                                                sx={{ fontSize: '13px' }}
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '224px',
                                                        '& .MuiAutocomplete-option': {
                                                            fontSize: '13px',  // Set the font size for the options
                                                        },
                                                    },
                                                }}
                                                renderOption={(props, option) => (
                                                    <li {...props} style={{ fontSize: '13px' }}>
                                                        {option[control.DisplayExpr]}
                                                    </li>
                                                )}

                                            />
                                            {errors[control.ValueExpr] && (targetClassificationValue === '' || targetClassificationValue === null || targetClassificationValue?.length === 0 || targetClassificationValue === undefined) && (  // NOSONAR
                                                <FormHelperText sx={{ color: 'red', fontSize: '10px' }}>{errors[control?.ValueExpr]?.message}</FormHelperText>
                                            )}
                                        </FormControl>
                                    ))
                                }
                                {
                                    values.TargetClassification && targetSubClassification && targetSubClassification.DataType === 'MultiselectDropdown' && (
                                        <FormControl fullWidth>
                                            <style>
                                                {`.css-pwhq7a-MuiTypography-root {font-size: 13px !important;}`}

                                            </style>
                                            {/* <InputLabel size='small' sx={{ fontSize: '14px' }}>{targetSubClassification.LabelName}</InputLabel> */}
                                            <Autocomplete
                                                multiple
                                                size='small'
                                                key={targetClassification}
                                                value={selectedValues}
                                                {...register(targetSubClassification.ValueExpr, { required: 'Target Subclassification required' })}
                                                disableClearable
                                                    onChange={(event, newValue, reason) => {
                                                        if (!(reason === 'removeOption' && event.type === 'keydown')) {

                                                            setSelectedValues(newValue);

                                                            setValue(targetSubClassification.ValueExpr, newValue);
                                                        }
                                                }}
                                                options={targetSubClassification.DefaultValues || []}
                                                getOptionLabel={(option) => option[targetSubClassification.DisplayExpr] || option[targetSubClassification.ValueExpr]}
                                                renderInput={(params) => (
                                                    <Tooltip
                                                        id="tooltip-title-id"
                                                        title={
                                                            <div
                                                                style={{
                                                                    maxHeight: '150px',
                                                                    overflowY: selectedValues?.length > 3 ? 'auto' : 'hidden', // Show scrollbar only if there are more than 3 items
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        color: '#9e9e9e',
                                                                        fontSize: '12px',
                                                                        fontWeight: '300',
                                                                    }}
                                                                >
                                                                    {selectedValues?.map(item => item[targetSubClassification.DisplayExpr]).join(', ') || 'No items selected'}
                                                                </span>
                                                            </div>
                                                        }

                                                        arrow
                                                        placement="top"
                                                        PopperProps={{
                                                            sx: {
                                                                '& .MuiTooltip-tooltip': {
                                                                    backgroundColor: 'white', // White background
                                                                    color: 'black', // Black text
                                                                    border: '1px solid #ccc', // Optional: subtle border for better visibility
                                                                    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                                                },
                                                                '& .MuiTooltip-arrow': {
                                                                    color: '#f9f9f9', // Match the arrow color with the tooltip background
                                                                },
                                                                display: selectedValues?.length === 0 || selectedValues === undefined || selectedValues === null ? 'none' : '', // Fix conditional syntax
                                                            },
                                                        }}
                                                    >
                                                        <TextField
                                                            {...params}
                                                            label={targetSubClassification.LabelName}
                                                            value={searchedValue}
                                                            onChange={e => setSearchedValue(e.target.value)}
                                                            variant="outlined"
                                                            size='small'
                                                            sx={{
                                                                '& .MuiInputBase-input': {
                                                                    fontSize: '13px',  // Set text size to 13px
                                                                },
                                                                '& .MuiFormLabel-root': {
                                                                    fontSize: '14px',  // Set label text size to 14px
                                                                },
                                                            }}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                endAdornment: (
                                                                    <>
                                                                        {params.InputProps.endAdornment}
                                                                        {selectedValues?.length > 0 && (
                                                                            <IconButton
                                                                                onClick={() => {
                                                                                    setSelectedValues([]); // Clear the beneficiary names
                                                                                }}
                                                                                size="small"
                                                                                style={{ padding: 0 }}
                                                                            >
                                                                                <CloseIcon fontSize="small" />
                                                                            </IconButton>
                                                                        )}
                                                                    </>
                                                                ),
                                                            }}

                                                        />
                                                    </Tooltip>

                                                )}
                                                renderTags={(value, getTagProps) =>
                                                    <span style={{ fontSize: '13px', paddingLeft: '0.5em' }}>{`${value.length} item${value.length !== 1 ? 's' : ''} selected`}</span>
                                                }
                                                slots={{ paper: custom }}
                                                slotProps={{ paper: { targetSubClassification, selectedValues, searchedValue, setSelectedValues, setValue } }}

                                                PaperComponent={custom}


                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox
                                                            size='small'
                                                            // checked={selectedValues.length === targetSubClassification.DefaultValues.length ? selectedValues.length === targetSubClassification.DefaultValues.length : selected}
                                                            checked={selectedValues.includes(option)}
                                                        />
                                                        <ListItemText
                                                            primary={option[targetSubClassification.DisplayExpr] || option[targetSubClassification.ValueExpr]}
                                                            primaryTypographyProps={{ style: { fontSize: '13px' } }}
                                                        />
                                                    </li>
                                                )}


                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '224px',
                                                        '& .MuiAutocomplete-option': {
                                                            fontSize: '13px',  // Set the font size for the options
                                                        },
                                                    },
                                                }}
                                                disableCloseOnSelect
                                            />
                                            {errors[targetSubClassification?.ValueExpr] && (selectedValues.length === 0) && (
                                                <FormHelperText sx={{ color: 'red', fontSize: '10px' }}>{errors[targetSubClassification?.ValueExpr]?.message}</FormHelperText>
                                            )}
                                        </FormControl>
                                    )
                                }

                                {
                                    targetSubClassification && targetSubClassification.DataType === 'Autocomplete' && (
                                        <FormControl fullWidth size='small'>


                                            <Autocomplete
                                                multiple
                                                disableCloseOnSelect

                                                size='small'
                                                value={selectedValues}
                                                options={targetSubClassification.DefaultValues || []}
                                                getOptionLabel={(option) => option.Classification}
                                                renderOption={(props, option, { selected }) => {
                                                    // eslint-disable-next-line react/prop-types
                                                    const { key, ...optionProps } = props;
                                                    return (
                                                        <li key={key} {...optionProps} style={{ fontSize: '13px' }}>
                                                            <Checkbox
                                                                size='small'

                                                                style={{ marginRight: 8 }}
                                                                checked={selectedValues.includes(option)}
                                                            />
                                                            {option.Classification}
                                                        </li>
                                                    );
                                                }}
                                                renderTags={(selected) => {
                                                    const selectedCount = selected.length;
                                                    return (
                                                        <span style={{ paddingLeft: '8px', fontSize: '13px' }}>
                                                            {selectedCount === 1
                                                                ? `${selectedCount} item selected`
                                                                : `${selectedCount} items selected`}
                                                        </span>
                                                    );
                                                }}

                                                renderInput={(params) => (

                                                    <Tooltip
                                                        title={
                                                            <div
                                                                style={{
                                                                    maxHeight: '150px',
                                                                    overflowY: selectedValues?.length > 3 ? 'auto' : 'hidden', // Show scrollbar only if there are more than 3 items
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        color: '#9e9e9e',
                                                                        fontSize: '12px',
                                                                        fontWeight: '300',
                                                                    }}
                                                                >
                                                                    {selectedValues?.map(item => item[targetSubClassification.DisplayExpr]).join(', ') || 'No items selected'}
                                                                </span>
                                                            </div>
                                                        }
                                                        arrow
                                                        placement="top"

                                                        PopperProps={{
                                                            sx: {
                                                                '& .MuiTooltip-tooltip': {
                                                                    backgroundColor: 'white', // White background
                                                                    color: 'black', // Black text
                                                                    border: '1px solid #ccc', // Optional: subtle border for better visibility
                                                                    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                                                },
                                                                '& .MuiTooltip-arrow': {
                                                                    color: '#f9f9f9', // Match the arrow color with the tooltip background
                                                                },
                                                                display: selectedValues?.length === 0 || selectedValues === undefined || selectedValues === null ? 'none' : '', // Fix conditional syntax
                                                            },
                                                        }}
                                                    >

                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            label={<span style={{ fontSize: '13px' }}>{targetSubClassification.LabelName}</span>}
                                                            variant="outlined"
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                endAdornment: (
                                                                    <>
                                                                        {AutocompleteLoadingMap.get(targetSubClassification?.ValueExpr) ? <CircularProgress color="inherit" size={20} /> : null}
                                                                        {params.InputProps.endAdornment}
                                                                    </>
                                                                ),
                                                            }}
                                                            size='small'
                                                            sx={{
                                                                '& .MuiInputBase-input': {
                                                                    fontSize: '13px',  // Set text size to 13px
                                                                },
                                                                '& .MuiFormLabel-root': {
                                                                    fontSize: '14px',  // Set label text size to 14px
                                                                },
                                                            }}
                                                        />
                                                    </Tooltip>
                                                )}
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '224px',
                                                        '& .MuiAutocomplete-option': {
                                                            fontSize: '13px',  // Set the font size for the options
                                                        },
                                                    },
                                                }}

                                                PaperComponent={(paperProps) => {  // NOSONAR
                                                    const { children, ...restPaperProps } = paperProps;
                                                    return (
                                                        <Paper {...restPaperProps}>

                                                            <Box onMouseDown={(e) => e.preventDefault()} sx={{ display: 'flex', height: '2rem', alignItems: 'center', paddingLeft: '2.142em' }}>

                                                                <FormControlLabel
                                                                    onClick={(e) => {
                                                                        e.preventDefault(); // prevent blur

                                                                        const allValues = targetSubClassification.DefaultValues;

                                                                        if (selectedValues.length < allValues.length) {
                                                                            // Select all items
                                                                            setSelectedValues(allValues);
                                                                            setValue(targetSubClassification.ValueExpr, targetSubClassification.DefaultValues);
                                                                        } else {
                                                                            // Unselect all items
                                                                            setSelectedValues([]);
                                                                            setValue(targetSubClassification.ValueExpr, []);
                                                                        }
                                                                    }}
                                                                    label={
                                                                        <span style={{ fontSize: '13px !important' }}>
                                                                            {selectedValues?.length === targetSubClassification?.DefaultValues?.length ? 'Unselect All' : 'Select All'}
                                                                        </span>
                                                                    } control={
                                                                        <Checkbox size='small' id="select-all-checkbox" checked={targetSubClassification.DefaultValues?.length > 0 && selectedValues?.length === targetSubClassification.DefaultValues?.length} />
                                                                    }
                                                                />
                                                            </Box>
                                                            <Divider />
                                                            {children}
                                                        </Paper>
                                                    );
                                                }}
                                                loading={AutocompleteLoadingMap.get(targetSubClassification?.ValueExpr)}

                                                onInputChange={(event, newInputValue) => {
                                                    if (newInputValue.length >= 3) {
                                                        const fetchAutoCompleteOptions = async () => {
                                                            try {
                                                                const payload = {
                                                                    ControlId: `${targetSubClassification.TableName}-${targetSubClassification.DisplayExpr}`,
                                                                    Values: newInputValue,
                                                                    SchemeId: Number(idKey)
                                                                };

                                                                // Call SchemeDefinationService and fetch data
                                                                const schemeDefinationInstance = await SchemeDefinationService; // Properly await for service instance

                                                                // Use await to get the response from the autocomplete API call
                                                                setAutocompleteLoadingMap(prev => new Map(prev).set(targetSubClassification?.ValueExpr, true));

                                                                const response = await schemeDefinationInstance.SchemeTargetAutoComplete(payload);
                                                                setAutocompleteLoadingMap(prev => {
                                                                    const newMap = new Map(prev);
                                                                    newMap.delete(targetSubClassification?.ValueExpr);
                                                                    return newMap;
                                                                });
                                                                // Check if the response is successful
                                                                if (response.status === 200) {
                                                                    const newOptions = response.data;

                                                                    // Update state properly
                                                                    setTargetSubClassification(prevState => ({
                                                                        ...prevState,
                                                                        DefaultValues: newOptions // Assuming you want to overwrite the previous values
                                                                    }));

                                                                }
                                                            } catch (error) {
                                                                console.error('Error fetching autocomplete options:', error);
                                                                setAutocompleteLoadingMap(prev => {
                                                                    const newMap = new Map(prev);
                                                                    newMap.delete(targetSubClassification?.ValueExpr);
                                                                    return newMap;
                                                                });
                                                            }
                                                        };

                                                        fetchAutoCompleteOptions(); // Call the async function
                                                    }
                                                }}

                                                    onChange={(event, newValue, reason) => {
                                                        if (!(reason === 'removeOption' && event.type === 'keydown')) {
                                                            // eslint-disable-next-line react/prop-types
                                                            // const ids = newValue.map(item => item[Object.keys(item).find(key => key.toLowerCase().includes("id"))]);
                                                            const ids = newValue;
                                                            setValue(targetSubClassification.ValueExpr, newValue);

                                                            setSelectedValues(ids);
                                                        }
                                                }}
                                                sx={{
                                                    maxHeight: '35.69px'
                                                }}


                                            />


                                            {errors[targetSubClassification.ValueExpr] && (selectedValues.length === 0) && (
                                                <FormHelperText sx={{ color: 'red', fontSize: '10px' }}>{errors[targetSubClassification?.ValueExpr]?.message}</FormHelperText>
                                            )}
                                        </FormControl>
                                    )
                                }

                            </Box>
                            <Stack
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="center"
                                sx={{ py: 1 }}
                            >
                                <Button type='submit'
                                    title='Add'
                                    variant='contained'
                                    sx={{
                                        height: '30px',
                                        width: '31px',
                                        bgcolor: '#1badd1',
                                        borderRadius: '4px',
                                        minWidth: 'auto',
                                        fontSize: '25px',
                                        '&:hover': {
                                            bgcolor: '#1badd1',
                                        },
                                    }}
                                >
                                    +
                                </Button>

                            </Stack>
                        </Box>
                    }

                    {/* <Divider sx={{ mt: 1 }} />
*/}




                    <div style={{ flexGrow: 1, overflow: 'auto' }}>
                        <> </>
                        <SchemeTargetDataGrid setAllTabData={setTargetDataa} record={record} targetValues={targetValues}  setTargetValues={setTargetValues} setRecord={setRecord} gridData={gridData} schemeLock={schemeDetails?.SchemeLock} ref={childRef} handleSave={saveDataa} targetClassificationValue={(targetClassificationValue.length !== 0) ? targetClassificationValue[0] : ''} />
                    </div>


                </Box>
               

                {/* Divider */}
                <Divider sx={{ mt: 2 }} />

                {/* Save button fixed at the bottom */}
                <Box sx={{ mt: 1 }}>
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        spacing={2}
                        alignItems="center"
                        sx={{ padding: '2px' }}
                    >

                        {isConfirmationOpen && (
                            <ConfirmationPopup
                                title="Confirm Action"
                                msg="Do you want to clear the values?"
                                setOpen={setIsConfirmationOpen}
                                onConfirm={handleConfirm}
                            >
                                {/* You can pass additional children here if needed */}
                            </ConfirmationPopup>
                        )}
                        {schemeDetails?.SchemeLock !== true && (
                            <Tooltip title="Save">
                                <IconButton type='button' onClick={() => saveData()} sx={{
                                    bgcolor: '#43b5a2',
                                    color: '#fff',
                                    borderRadius: '4px',
                                    height: '30px',
                                    width: '31px',
                                    padding: '4px',
                                }}>
                                    <Iconify icon="bx:save" />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Stack>
               
                </Box>


            </form>




            {showAlert && (
                <Stack sx={{ width: '30%', position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -40%)" }} spacing={2}>
                    <Alert
                        severity={alertType}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setAlertType('');
                                    setAlertMessage('');
                                    setShowAlert(false);
                                }}
                            >
                                <CloseIcon fontSize="16px" />
                            </IconButton>
                        }
                    >
                        {alertMessage}
                    </Alert>
                </Stack>
            )}
            {loading && <LoadingProgressBar />}
        </div>
    )
}